import axiosInstance from 'helpers/axiosInstance';

import { Lead } from './leads.type';

export const updateLead = async (
  leadId: string,
  updates: Partial<Lead> & {
    insuranceCardFront?: File;
    insuranceCardBack?: File;
  },
) => {
  return axiosInstance
    .patch<Lead>(`/patients/leads/${leadId}`, updates)
    .then(r => r.data);
};
